import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import {
 IBaremetalDataset,
 IBaremetalManageAPI,
 IFirewallBarmetalData
} from "types/api/baremetalApiInterface";

const initialState: IBaremetalManageAPI = { firewall: null, baremetal: null };

const BaremetalManageReducer = createSlice({
 name: "baremetalManage",
 initialState,
 reducers: {
  setFirewall: (state, { payload }: PayloadAction<IFirewallBarmetalData>) => {
   return { ...state, firewall: payload };
  },
  setBaremetalData: (state, { payload }: PayloadAction<IBaremetalDataset>) => {
   return { ...state, baremetal: payload };
  },
  resetBaremetalData: (state) => {
   return { ...state, baremetal: null };
  },
  resetFirewall: (state) => {
   return { ...state, firewall: null };
  }
 }
});

export default BaremetalManageReducer;
